import {createDealerMap} from "./dealerSearch/dealerSearchMap";
import {createDealerList} from "./dealerSearch/dealerSearchList";
import {initDealerAddressAutocomplete} from "./dealerSearch/dealerSearchAddress";

export function initDealerSearch() {
    const mapContainer = document.getElementById("dealerSearchMap");
    const listContainer = document.getElementById("dealerSearchItems");
    const emptyNotice = document.getElementById("dealerSearchEmpty");
    if (!mapContainer) {
        return;
    }

    const config = window.dealerSearchConfig || {};
    const lang = document.body.dataset.lang_code;

    const {map, markerCluster, markerIconDefault, markerIconActive} = createDealerMap(mapContainer, config);

    const dealerList = createDealerList({
        listContainer, emptyNotice, map, markerCluster, markerIconDefault, markerIconActive, lang, config
    });

    const filterBar = document.getElementById("dealerSearchFilters");
    if (filterBar) {
        filterBar.addEventListener("click", function (event) {
            const button = event.target.closest(".dealerSearch__filter");
            if (!button) return;
            dealerList.setFilter(button.dataset.filter || "all");
            filterBar.querySelectorAll(".dealerSearch__filter").forEach(b => b.classList.toggle("is-active", b === button));
            dealerList.render();
        });
    }

    dealerList.setDealers(config.dealers || []);
    dealerList.render();

    initDealerAddressAutocomplete(lang);
}
